import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { CssBaseline } from "@mui/material";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { initSyncService, registerSyncTriggers } from "./app/syncService";

// Initialise offline sync service with the Redux store
initSyncService(store);
registerSyncTriggers();

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <CssBaseline />
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

// Register the service worker for PWA + offline-first app shell caching
serviceWorkerRegistration.register();
